import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectComponent} from '@ng-select/ng-select';
import {Subscription} from 'rxjs';
import {IYii} from '../../../globals';
import {AssignmentService} from '../services/AssignmentService';
import {FormService} from '../services/FormService';
import {ProgressBar} from 'primeng/progressbar';
import {DisplayFieldsService} from '../services/display-fields.service';

declare var Yii: IYii;

@Component({
  selector: 'ng-assignments-display-fields',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectComponent,
    ProgressBar,
  ],
  templateUrl: './assignments-display-fields.html'
})
export class AssignmentsDisplayFields implements OnInit, OnDestroy {
  public Yii = Yii;
  private subs: Subscription[] = [];

  constructor(
    public asvc: AssignmentService,
    public fsvc: FormService,
    public svc: DisplayFieldsService
  ) {
  }

  ngOnInit(): void {
    this.subs.push(this.asvc.OnChainChanged.subscribe({next: () => this.svc.Load()}))
    this.subs.push(this.asvc.OnBranchChanged.subscribe({next: () => this.svc.Load()}))
    this.svc.Load();
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
